export class StyxClientHostEvents {
    public static get Reload(): string {
        return "reload";
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/FireBird/FireBirdTypes.ts
 **/